import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { HatchBand, Version } from "@jbnl/shared-ui";
import { Footer } from "@/components/brand/Footer";
import { Logo } from "@/components/brand/Logo";

/**
 * The planner's signed-out letterhead: the lockup over one narrow white column. The sidebar frame
 * lives in AppShell, so the eagerly loaded sign-in pages keep the sidebar out of the main chunk.
 */
export function Shell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-screen flex-col bg-background">
      <HatchBand />
      <div className="mx-auto w-full max-w-2xl px-6 pt-status-bar-12 pb-12">
        <div className="mb-8 border-b border-brand-blue pb-4">
          <Link to="/" className="flex items-center gap-4 rounded-sm">
            <Logo className="h-14" />
            <span className="font-bold tracking-[-0.02em] whitespace-nowrap">{t("shell.title")}</span>
          </Link>
        </div>
        {children}
        <Version className="mt-10" />
      </div>
      <Footer />
    </div>
  );
}
